/* eslint-disable jsx-a11y/alt-text */
import signup from "../../../assets/svg/signup.svg";
import google from "../../../assets/images/gplay1.png";
import apple from "../../../assets/images/apple1.png";

import styles from "../five/five.module.scss";
import { Link, useNavigate } from "react-router-dom";
const Five = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.main_wrapper}>
      <div className={styles.first}>
        {/* <img className={styles.img_} src={first} /> */}
        <div className={styles.text}>
          <span>For Homeowners</span>
          <p>
            Download our Homeowners App and get started.
            <br /> Have questions, {window.innerWidth < 768 && <br />}call us{" "}
            <a style={{ color: "white" }} href="tel:+19734494171">
              973-449-4171
            </a>
          </p>
          <div className={styles.main_first_btn}>
            <button
              onClick={() => {
                navigate("/contactus");
              }}
            >
              Contact us
            </button>
            <div className={styles.new_img}>
              <img src={google} />
              <a href="https://apps.apple.com/us/app/cid-inspections/id6480584493">
                <img className="ms-3" src={apple} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.second}>
        <div className={styles.box}>
          <span className={styles.town}>For Townships</span>
          <p className={styles.sign}>
            Sign in to manage your inspections requirements. <br /> New to CID
            ? 
            <a
              onClick={() => {
                navigate("/aboutus");
              }}
            >
              Click here to learn more.
            </a>
          </p>
          <div className={styles.bottons}>
            <Link to="https://vendor.cidusa.net/register" target="_blank">
              <button className={styles.signup}>
                <img src={signup} /> Sign up
              </button>
            </Link>
            <Link to="https://vendor.cidusa.net" target="_blank">
              <button className={styles.acc}>
                Already have an account? log in
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className={`${styles.first_new}  ${styles.tab}`}>
        {/* <img className={styles.img_} src={first} /> */}
        <div className={styles.text}>
          <span>For Builders and Contractors</span>
          <p className={styles.sign}>
            Sign in to manage your inspections requirements. <br /> New to CID
            ? 
            <a
              onClick={() => {
                navigate("/aboutus");
              }}
              style={{ textDecoration: "underline" }}
            >
              Click here to learn more.
            </a>
          </p>
          <div className={styles.bottons}>
            <Link to="https://vendor.cidusa.net/register" target="_blank">
              <button className={styles.signup}>
                <img src={signup} /> Sign up
              </button>
            </Link>
            <Link to="https://vendor.cidusa.net" target="_blank">
              <button className={styles.acc}>
                Already have an account? log in
              </button>
            </Link>
          </div>
        </div>
      </div>
      {/* <div className={styles.last}>
        <img src={second} />
        <div className={styles.text}>
          <span>For Builders and Contractors</span>
          <p>
            Sign in to manage your inspections requirements. New to CCI ? Click
            here to know more.
          </p>
          <div className={styles.bottons}>
            <Link to="https://stage.cidusa.net/register" target="_blank">
              <button className={styles.signup}>
                <img src={signup} /> Sign up
              </button>
            </Link>
            <Link to="https://stage.cidusa.net" target="_blank">
              <button className={styles.acc}>
                Already have an account? Log In
              </button>
            </Link>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Five;
